/*
Author: Eli Elad Elrom
Website: https://EliElrom.com
License: MIT License
Component: src/model/userObject.ts
*/

// eslint-disable-next-line @typescript-eslint/naming-convention
export interface userObject {
  memberId: string;
  email: string;
  encryptPasswordURI: string;
  isLightsOn: boolean;
}

export const initUser = (): userObject => ({
  memberId: '',
  email: '',
  encryptPasswordURI: '',
  isLightsOn: true,
});
